import { useQuery } from '@tanstack/react-query';
import fetchCustomerList from '@data/selloutMonitoring/fetchCustomerList';
import getCustomerListResponse from '@domain/model/response/selloutMonitoring/getCustomerListResponse';

export const useGetCustomerList = ({ enabled, search }) => {
    return useQuery({
        queryKey: ['list-customer', search],
        queryFn: async () => {
            const data = await fetchCustomerList(search);
            const res = getCustomerListResponse(data);
            return res;
        },
        enabled: enabled,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};
